import fetchApi from '../../services/fetchApi';
import * as AT from './_types';

export const fetchActiveHours = (activeLocationId) => dispatch => {
  dispatch({ type: AT.ACTIVE_HOURS_FETCHING });
  let url = '/active_hours';
  if (activeLocationId) {
    const queryParams = new URLSearchParams({ location_id: activeLocationId }).toString();
    url += `?${queryParams}`;
  }
  return fetchApi(url, 'GET')
    .then(hours => {
      dispatch({ type: AT.ACTIVE_HOURS_FETCHED, payload: hours });
    })
    .catch(error => console.error('Fetching active hours failed', error));
};

export const updateActiveHours = (hours) => dispatch => {
  dispatch({ type: AT.ACTIVE_HOURS_UPDATING });
  return fetchApi('/active_hours', 'PATCH', { body: JSON.stringify(hours) })
    .then(updatedHours => {
      dispatch({ type: AT.ACTIVE_HOURS_UPDATED, payload: updatedHours });
    })
    .catch(error => console.error('Updating active hours failed', error));
};


// WEBPACK FOOTER //
// ./src/state/actions/active-hours.js